import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {HomePage} from '../pages/home/HomePage'
import {RespiratorySyndroms} from '../pages/home/fr/social-media/respiratory-sydroms-in-social-media/RespiratorySyndroms'
import {DoctorVisits} from '../pages/home/fr/ambulatory-care/doctor-visits-for-respiratory-syndroms/DoctorVisits'
import {HospitalAdmissions} from '../pages/home/fr/hospital/admissions-for-resp-syndroms/HospitalAdmissions'
import {DeathsForRespiratory} from '../pages/home/fr/hospital/deaths-for-respiratory-syndroms/DeathsForRespiratory'
import {EmergencyRoomVisits} from '../pages/home/fr/hospital/emergency-room-visits-for-resp-syndroms/EmergencyRoomVisits'
import {IcuAdmissions} from '../pages/home/fr/hospital/icu-admissions-for-resp-syndroms/IcuAdmissions'
import {Covid} from '../pages/home/fr/virology/covid-19-positivity-rate/Covid'
import {Influenza} from '../pages/home/fr/virology/influenza-positivity-rate/Influenza'
import {Rsv} from '../pages/home/fr/virology/rsv-positivity-rate/Rsv'
import {WasteWaterCovid} from '../pages/home/fr/virology/viral-load-in-wasterwater-covid-19/WasteWaterCovid'
const PublicFrRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='/' element={<HomePage />} />
        {/* Pages */}
        <Route path='dashboard' element={<HomePage />} />

        {/* Lazy Modules */}
        <Route
          path='respiratory-sydroms-in-social-media'
          element={
            <SuspensedView>
              <RespiratorySyndroms />
            </SuspensedView>
          }
        />
        <Route
          path='ambulatory-care_doctor-visits'
          element={
            <SuspensedView>
              <DoctorVisits />
            </SuspensedView>
          }
        />
        <Route
          path='hospital-emergency-room-visits'
          element={
            <SuspensedView>
              <EmergencyRoomVisits />
            </SuspensedView>
          }
        />
        <Route
          path='hospital-adminssions'
          element={
            <SuspensedView>
              <HospitalAdmissions />
            </SuspensedView>
          }
        />
        <Route
          path='icu-adminssions'
          element={
            <SuspensedView>
              <IcuAdmissions />
            </SuspensedView>
          }
        />
        <Route
          path='hospital-deaths-for-respiratory-synd'
          element={
            <SuspensedView>
              <DeathsForRespiratory />
            </SuspensedView>
          }
        />
        <Route
          path='virology-influenza'
          element={
            <SuspensedView>
              <Influenza />
            </SuspensedView>
          }
        />
        <Route
          path='virology-covid'
          element={
            <SuspensedView>
              <Covid />
            </SuspensedView>
          }
        />
        <Route
          path='virology-rsv'
          element={
            <SuspensedView>
              <Rsv />
            </SuspensedView>
          }
        />
        <Route
          path='virology-waste-water'
          element={
            <SuspensedView>
              <WasteWaterCovid />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PublicFrRoutes}
